import { render, staticRenderFns } from "./HonorSlot.vue?vue&type=template&id=57a15d18"
import script from "./HonorSlot.vue?vue&type=script&lang=js"
export * from "./HonorSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports